<script setup lang="ts">
import SectionStepsView from '../../views/SectionStepsView/SectionStepsView.vue';
import BPage from 'src/shared/components/base/BPage/BPage.vue';
</script>

<template>
  <BPage>
    <div class="col fit overflow-auto">
      <SectionStepsView
        :user-section-doc-id="$route.params.userSectionDocId as string"
      />
    </div>
  </BPage>
</template>
